export type SensorDetailReportState = {
    loading: boolean;
    success: boolean;
    errorCode: string;  
    deviceId: string;
    deviceName: string;
    channelData: Array<{
        channelNumber: number;
        channelName: string;
        pdData: {
            highPdi: string;
            pdiAlarmPoint: string;
            highQmax: string;
            qmaxAlarmPoint: string;
            highPps: string;
            highPpc: string;
        };
    }>;
};

export const initialSensorDetailReport: SensorDetailReportState = {
    loading: false,
    success: false,
    errorCode: '',  
    deviceId: '',
    deviceName:'',
    channelData: []
  
};
